<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <span class="font-weight-regular">ดาว์นโหลด Transaction (NFC)</span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pa-5">
        <v-form ref="form" lazy-validation @submit.prevent="onSubmit">
          <v-row>
            <v-col md="3" xl="2">
              <DatePicker
                :label="dateStartLabel"
                :value="dateStartValue"
                :max="dateEndValue"
                :hideDetails="true"
                @input="dateStartInput"
              />
            </v-col>
            <v-col md="3" xl="2">
              <DatePicker
                :label="dateEndLabel"
                :value="dateEndValue"
                :min="dateStartValue"
                :hideDetails="true"
                @input="dateEndInput"
              />
            </v-col>
          </v-row>
          <div class="mt-5">
            <h4>ทะเบียนรถ</h4>
            <v-radio-group class="mt-2" v-model="licensePlateSelected">
              <v-radio label="ทั้งหมด" value="LICENSE_PLATE_ALL"></v-radio>
              <div class="d-flex">
                <v-radio
                  label="เฉพาะที่กำหนด"
                  value="LICENSE_PLATE_SPECIFY"
                ></v-radio>
                <div class="ml-3">
                  <v-text-field
                    v-model="licensePlate"
                    outlined
                    dense
                    hide-details
                    @change="checkEmpty($event, 'licensePlate')"
                  ></v-text-field>
                </div>
              </div>
            </v-radio-group>
          </div>
          <div class="mt-5">
            <h4>รหัสพนักงาน หรือ Serial Card</h4>
            <v-radio-group class="mt-2" v-model="empIdentifiableSelected">
              <v-radio label="ทั้งหมด" value="EMP_IDENTIFIABLE_ALL"></v-radio>
              <div class="d-flex">
                <v-radio
                  label="เฉพาะที่กำหนด"
                  value="EMP_IDENTIFIABLE_SPECIFY"
                ></v-radio>
                <div class="ml-3">
                  <v-text-field
                    v-model="empIdentifiable"
                    outlined
                    dense
                    hide-details
                    @change="checkEmpty($event, 'empIdentifiable')"
                  ></v-text-field>
                </div>
              </div>
            </v-radio-group>
          </div>
          <div class="mt-5">
            <label>รหัสเครื่องบันทึกเวลา</label>
            <v-col cols="2" class="pa-0">
              <v-autocomplete
                v-model="hardwareSelected"
                :items="[
                  { hardware_code: 'HARDWARE_CODE_ALL', text: 'ทั้งหมด' },
                  ...filterHardwares,
                ]"
                item-text="text"
                item-value="hardware_code"
                outlined
                dense
              ></v-autocomplete>
            </v-col>
          </div>
          <div class="mt-5">
            <v-btn color="primary" @click="onDownload"
              >ดาวน์โหลดไฟล์ excel
            </v-btn>
          </div>
        </v-form>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialogProgress" persistent width="320">
      <div class="pa-4 white">
        <v-progress-linear :value="progressValue" height="25">
          <strong>{{ Math.ceil(progressValue) }}%</strong>
        </v-progress-linear>
      </div>
    </v-dialog>
  </v-container>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'

// @ is an alias to /src
import DatePicker from '@/components/DatePicker.vue'

export default {
  components: {
    DatePicker,
  },

  data() {
    return {
      dialogProgress: false,
      progressValue: 0,
      hardwareSelected: 'HARDWARE_CODE_ALL',
      licensePlateSelected: 'LICENSE_PLATE_ALL',
      licensePlate: '',
      empIdentifiableSelected: 'EMP_IDENTIFIABLE_ALL',
      empIdentifiable: '',
      dateStartLabel: 'วันที่เริ่มต้น',
      dateStartValue: moment().format('YYYY-MM-DD'),
      dateEndLabel: 'วันที่สิ้นสุด',
      dateEndValue: moment().format('YYYY-MM-DD'),
      interval: null,
      timeout: null,
    }
  },
  computed: {
    filterHardwares() {
      return this.$store.state.hardware.hardwares
        .map((hardware) => ({
          hardware_code: hardware.hardware_code,
          text: hardware.title_th
            ? `${hardware.hardware_code} - ${hardware.title_th}`
            : hardware.hardware_code,
        }))
        .sort((a, b) => a.hardware_code.localeCompare(b.hardware_code))
    },
  },
  created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'ดาว์นโหลด Transaction (NFC)',
        disabled: true,
      },
    ])

    const { company_uuid } = this.$store.state.authentication.company

    this.$store.state.loading = true

    const payload = {
      params: {
        dpc: 'download-transaction-nfc-to-list-hardware',
        company_uuid,
        hardware_model_code: 'q2,q3',
      },
    }
    this.fetchHardwares(payload)
      .then(() => {
        this.$store.state.loading = false
      })
      .catch((error) => {
        this.$store.state.loading = false

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      })
  },
  methods: {
    ...mapActions({
      fetchHardwares: 'hardware/fetchHardwares',
      downloadTransactionNfc: 'download/downloadTransactionNfc',
      generateFileProgress: 'download/generateFileProgress',
    }),
    checkEmpty(value, field) {
      if (value) {
        this[field] = value.trim()
      }
    },
    dateStartInput(value) {
      this.dateStartValue = value
    },
    dateEndInput(value) {
      this.dateEndValue = value
    },
    onDownload() {
      const { company_uuid } = this.$store.state.authentication.company

      const payload = {
        company_uuid,
        body: {
          start_date: this.dateStartValue,
          end_date: this.dateEndValue,
          license_plate:
            this.licensePlateSelected === 'LICENSE_PLATE_ALL'
              ? []
              : [this.licensePlate],
          hardware_code:
            this.hardwareSelected === 'HARDWARE_CODE_ALL'
              ? []
              : [this.hardwareSelected],
          employee_identifiable:
            this.empIdentifiableSelected === 'EMP_IDENTIFIABLE_ALL'
              ? []
              : [this.empIdentifiable],
        },
      }

      this.$store.state.loading = true
      this.downloadTransactionNfc(payload)
        .then((res) => {
          this.$store.state.loading = false

          if (res.total === 0) {
            const snackbar = {
              show: true,
              color: 'warning',
              timeout: 4000,
              message: 'ไม่มีข้อมูล',
            }

            this.$store.commit('SET_SNACKBAR', snackbar)
            return
          }

          this.progressValue = 0
          this.dialogProgress = true

          this.downloadProgress(res.job_process_uuid, res.ping_after_ms)
        })
        .catch((error) => {
          this.$store.state.loading = false
          this.dialogProgress = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    downloadProgress(job_process_uuid, ping_after_ms) {
      this.interval = setInterval(() => {
        this.generateFileProgress(job_process_uuid)
          .then((res) => {
            if (res.total === 0) {
              this.progressValue = 100
              this.timeout = setTimeout(() => {
                this.dialogProgress = false
              }, 200)

              clearInterval(this.interval)

              const snackbar = {
                show: true,
                color: 'warning',
                timeout: 4000,
                message: 'ไม่มีข้อมูล',
              }

              this.$store.commit('SET_SNACKBAR', snackbar)
              return
            }

            if (res.is_success) {
              this.progressValue = 100
              this.timeout = setTimeout(() => {
                this.dialogProgress = false
              }, 200)

              const fileUrl = res.resource_uri
              const fileName = fileUrl.split('/').pop()

              const a = document.createElement('a')
              a.setAttribute('hidden', '')
              a.setAttribute('href', fileUrl)
              a.setAttribute('download', fileName)
              document.body.appendChild(a)
              a.click()
              document.body.removeChild(a)

              clearInterval(this.interval)
            } else {
              this.progressValue = (100 / res.total) * res.progress
            }
          })
          .catch((error) => {
            this.dialogProgress = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)

            clearInterval(this.interval)
          })
      }, ping_after_ms)
    },
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  },
}
</script>
